module.exports = __webpack_public_path__ + "media/images/baseline_keyboard_arrow_down_black_18dp-208773f5.png";